export class Bookmark {

	constructor(
		public bookmarkId?: number | null,
		public name?: string,
		public isDefault?: boolean,
		public bookmarksGroupId?: number,
	) {}
}
